import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import DrinkFinder from "@/pages/DrinkFinder";
import Cocktails from "@/pages/Cocktails";
import Learn from "@/pages/Learn";
import LearnArticle from "@/pages/LearnArticle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Saved from "@/pages/Saved";
import SpiritCatalog from "@/pages/SpiritCatalog";
import BarCart from "@/pages/BarCart";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/drink-finder" element={<DrinkFinder />} />
            <Route path="/cocktails" element={<Cocktails />} />
            <Route path="/saved" element={<Saved />} />
            <Route path="/whisky" element={<SpiritCatalog />} />
            <Route path="/wine" element={<SpiritCatalog />} />
            <Route path="/beer" element={<SpiritCatalog />} />
            <Route path="/rum" element={<SpiritCatalog />} />
            <Route path="/bar-cart" element={<BarCart />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/learn/:slug" element={<LearnArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}
